/* eslint-disable jsx-a11y/no-noninteractive-element-interactions,jsx-a11y/anchor-has-content */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';

import {
  setFieldModelClass,
  setFieldModelId,
  setFieldTypes,
  setFieldContent,
  sendForm,
  initState
} from 'mt-react-common/modules/complaints/addComplaintForm/actions';

import {
  hasFieldError,
  selectFirstErrorByFiled,
  clearErrorByField
} from 'mt-react-common/common/reducers/_formErrors/reducer';

import { selectRequestStatusData } from 'mt-react-common/common/reducers/_requestStatus/reducer';

import { getItemFromRefList } from 'mt-react-common/modules/main/reducers/static/states/referenceLists/reducer';
import OpacityPreLoader from '../../Common/PreLoaders/OpacityPreLoader';

class ComplaintReportPopUpForComment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      types: []
    };
  }

  componentDidMount() {
    this.props.setFieldModelClass('Comments');
    this.props.setFieldModelId(this.props.id);
  }

  componentDidUpdate(prevProps, prevState) {
    if (!_.isEqual(prevState.types, this.state.types)) {
      this.props.setFieldTypes(this.state.types);
    }
    if (
      prevProps.requestStatusData.codeResponse !==
        this.props.requestStatusData.codeResponse &&
      this.props.requestStatusData.codeResponse === 200
    ) {
      this.props.handleClose();
      this.props.initState();
    }
  }

  onChangeTypes = e => {
    const options = [...this.state.types];
    let index;
    if (e.target.checked) {
      options.push(+e.target.value);
    } else {
      index = options.indexOf(+e.target.value);
      options.splice(index, 1);
    }
    if (this.props.hasFieldError('types')) {
      this.props.clearErrorByField('types');
    }
    this.setState({ types: options });
  };

  onChangeContent = e => {
    e.preventDefault();
    if (this.props.hasFieldError('content')) {
      this.props.clearErrorByField('content');
    }
    this.props.setFieldContent(e.target.value);
  };

  render() {
    const errorDesc = fieldName => {
      if (this.props.hasFieldError(fieldName)) {
        return (
          <React.Fragment>
            <small className="help-block">
              {this.props.selectFirstErrorByFiled(fieldName).message}
            </small>
          </React.Fragment>
        );
      }
      return null;
    };
    return (
      <div
        className="modal-dialog"
        role="document"
        onClick={e => e.stopPropagation()}
      >
        {this.props.requestStatusData.requestInProcess ||
        this.props.requestStatusData.codeResponse === 200 ? (
          <OpacityPreLoader />
        ) : null}
        <div className="modal-content">
          <div className="modal-header text-center">
            {/* TODO Отрабатывает goBack на стороне js верстки, плохая ситуация, поправить */}
            <a
              href=""
              onClick={this.props.handleClose}
              className="close close-black"
            />
            <i className="fa fa-exclamation-triangle modal-icon" />
            <h4 className="modal-title">Пожаловаться на комментарий</h4>
            <p>
              Пожалуйста сообщите причину, по которой комментарий должен быть
              удален
            </p>
          </div>
          <form id="form">
            <div className="modal-body">
              <div
                className={`form-group ${
                  this.props.hasFieldError('types') ? 'has-error' : ''
                }`}
              >
                <label htmlFor="form" className="control-label">
                  Причина
                </label>
                {this.props.userDaysStatGroupByTypes.map(item => (
                  <div
                    className="control-group"
                    key={`userDaysStatGroupByTypeCheckbox${item.id}`}
                  >
                    <div className="checkbox abc-checkbox abc-checkbox-primary">
                      <input
                        type="checkbox"
                        value={item.id}
                        onChange={this.onChangeTypes}
                        name={`complaint-type-${item.id}`}
                        id={`complaint-type-${item.id}`}
                      />
                      <label htmlFor={`complaint-type-${item.id}`}>
                        {item.title}
                      </label>
                    </div>
                  </div>
                ))}
                {errorDesc('types')}
              </div>
              <div
                className={`form-group m-b-0 ${
                  this.props.hasFieldError('content') ? 'has-error' : ''
                }`}
              >
                <label
                  htmlFor="complaintTextarea"
                  className="col-sm-2 control-label"
                >
                  Комментарий
                </label>
                <textarea
                  onChange={this.onChangeContent}
                  className="form-control"
                  rows="3"
                  id="complaintTextarea"
                />
                {errorDesc('content')}
              </div>
            </div>
            <div className="modal-footer">
              {/* TODO Отрабатывает goBack на стороне js верстки, плохая ситуация, поправить */}
              <button
                type="button"
                className="btn btn-muted"
                onClick={this.props.handleClose}
              >
                Отмена
              </button>
              <button
                type="button"
                className="btn btn-danger"
                onClick={() => this.props.sendForm()}
              >
                Пожаловаться
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

ComplaintReportPopUpForComment.contextTypes = {
  router: PropTypes.shape()
};

ComplaintReportPopUpForComment.propTypes = {
  // IN
  handleClose: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  userDaysStatGroupByTypes: PropTypes.arrayOf(PropTypes.shape).isRequired,

  requestStatusData: PropTypes.shape({
    requestInProcess: PropTypes.bool,
    codeResponse: PropTypes.number
  }).isRequired,

  hasFieldError: PropTypes.func.isRequired,
  selectFirstErrorByFiled: PropTypes.func.isRequired,
  clearErrorByField: PropTypes.func.isRequired,

  setFieldModelClass: PropTypes.func.isRequired,
  setFieldModelId: PropTypes.func.isRequired,
  setFieldTypes: PropTypes.func.isRequired,
  setFieldContent: PropTypes.func.isRequired,
  sendForm: PropTypes.func.isRequired,
  initState: PropTypes.func.isRequired
};

const mapStateToProps = (state, props) => ({
  userDaysStatGroupByTypes: getItemFromRefList(state, 'complaintsTypes')[
    '2800284796'
  ],
  requestStatusData: selectRequestStatusData(props.reducerName, state),
  hasFieldError: fieldName =>
    hasFieldError(state, props.reducerName, fieldName),
  selectFirstErrorByFiled: fieldName =>
    selectFirstErrorByFiled(state, props.reducerName, fieldName)
});

const mapDispatchToProps = (dispatch, props) => ({
  clearErrorByField: value =>
    dispatch(clearErrorByField(props.reducerName, value)),
  setFieldModelClass: value =>
    dispatch(setFieldModelClass(props.reducerName, value)),
  setFieldModelId: value => dispatch(setFieldModelId(props.reducerName, value)),
  setFieldTypes: value => dispatch(setFieldTypes(props.reducerName, value)),
  setFieldContent: value => dispatch(setFieldContent(props.reducerName, value)),
  sendForm: () => dispatch(sendForm(props.reducerName)),
  initState: () => dispatch(initState(props.reducerName))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ComplaintReportPopUpForComment);



// WEBPACK FOOTER //
// ./src/components/Complaints/ComplaintReportPopUpForComment/ComplaintReportPopUpForComment.js